import AnimSection from "../AnimSection/AnimSection";
import "./Services.css";
import { NAV_LINKS } from "../../utils/constants";


export default function ServicesTemplate({ services }) {
  return (
    <section id={NAV_LINKS[0].id} className="services">
      <div className="section">

        <AnimSection>
          <span className="section-label">Ce automatizăm</span>
          <h2 className="section-title">
            Servicii pentru fiecare<br />tip de sarcină repetitivă
          </h2>
          <p className="services__subtitle">
            Nu vindem pachete fixe. Fiecare soluție e construită exact pentru fluxurile tale.
          </p>
        </AnimSection>

        <div className="services__grid">
          {services.map((service, i) => (
            <AnimSection key={i} delay={i * 80}>
              <div className="services__card">
                <span className="services__card-icon">{service.icon}</span>
                <h3 className="services__card-title">{service.title}</h3>
                <p className="services__card-desc">{service.desc}</p>
                <div className="services__card-tags">
                  {service.tags.map((tag) => (
                    <span key={tag} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            </AnimSection>
          ))}
        </div>

      </div>
    </section>
  );
}
